import { render, staticRenderFns } from "./EventNonTransactableWarning.vue?vue&type=template&id=86bc8d50&"
import script from "./EventNonTransactableWarning.vue?vue&type=script&lang=js&"
export * from "./EventNonTransactableWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports